import { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'

import TopUpCard from './TopUpCard'
import { Icon } from '../../UI'
import TopUpPaymentModal from './TopUpPaymentModal'
import TopUpSuccess from './TopUpSuccess'

import { topUpAmounts } from '../../../constants'

const TopUpModal = ({ currency, onClose, onContinue }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [paymentData, setPaymentData] = useState(null)
  const [isSuccessOpen, setIsSuccessOpen] = useState(false)

  const handleClose = () => {
    onClose()
  }

  const handleClosePaymentMethodModal = () => {
    setPaymentData(null)
    setIsOpen(true)
  }

  const handleSelect = (price) => {
    setIsOpen(false)
    setPaymentData({
      price,
      currency,
    })
  }

  const handlePaymentSuccess = () => {
    setIsOpen(false)
    setPaymentData(null)

    setTimeout(() => {
      setIsSuccessOpen(true)
    }, 0)
  }

  const handleCloseSuccess = () => {
    setIsSuccessOpen(false)
  }

  const handleContinueSuccess = () => {
    setIsSuccessOpen(false)

    onContinue()
  }

  useEffect(() => {
    setIsOpen(!!currency)
  }, [currency])

  const topUpAmountsContent = topUpAmounts.map((topUpAmount) => {
    return (
      <TopUpCard
        key={topUpAmount.title}
        currency={currency}
        topUpAmount={topUpAmount}
        onSelect={handleSelect}
      />
    )
  })

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        scroll="body"
        fullWidth
        classes={{
          paper:
            'relative xl:!max-w-[1124px] !p-[24px] !rounded-[12px] !bg-[#FDFDFD] !shadow-modal',
        }}
      >
        <button className="absolute top-[24px] right-[24px]">
          <Icon name="close" color="#FF9053" className="w-[24px] h-[24px]" />
        </button>

        <div className="flex flex-col items-center justify-center w-full">
          <h2 className="text-4xl text-primary-100 font-bold text-center">Top Up</h2>

          <h3 className="mt-[10px] text-2xl font-normal text-primary-100">Select Top Up Amount</h3>

          <div className="mt-[24px] w-full flex gap-[20px]">{topUpAmountsContent}</div>
        </div>
      </Dialog>

      <TopUpPaymentModal
        data={paymentData}
        onPayment={handlePaymentSuccess}
        onClose={handleClosePaymentMethodModal}
      />

      <TopUpSuccess
        open={isSuccessOpen}
        onClose={handleCloseSuccess}
        onContinue={handleContinueSuccess}
      />
    </>
  )
}

export default TopUpModal
